<template>
  <base-modal modal-content-class="bonus_modal midnight modal_glow">
    <div class="content">
      <base-image src="/static/images/discount.svg" image-class="bonus_img"></base-image>

      <h1>{{ modalHeaderText }}</h1>

      <div class="bonus_time">
        <h2>{{ pointsText }}</h2>

        <p>{{ durationText }}</p>

        <div class="timer_box">
          <base-countdown-timer
            :initial-timer-in-seconds="bonusPhaseCountdownTimer"
            timer-format="hh:mm:ss"
            class-name="bonus_timer"
            @time:expired="handleTimeExpired"
          ></base-countdown-timer>
        </div>
      </div>

      <div class="text">
        <p>{{ descriptionBetweenText }}</p>

        <p>{{ getTranslations.home_bundle_discount_purchase_now }}</p>
      </div>

      <base-button
        v-if="!hideStore"
        container-class="store"
        @button:click="$emit('redirect:storePage')"
      >
        {{ getTranslations.home_bundle_discount_store_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import Vue from 'vue'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import BaseImage from '../../../common/image/BaseImage'
import BaseCountdownTimer from '../../../common/timer/BaseCountdownTimer'

const moment = require('moment')

Vue.use(require('vue-moment'), {moment})

export default {
  name: 'bundle-discount',
  emits: ['redirect:storePage'],
  components: {
    BaseModal,
    BaseButton,
    BaseImage,
    BaseCountdownTimer
  },
  props: {
    startDate: {
      type: [String, Number, Date],
      default: ''
    },
    endDate: {
      type: [String, Number, Date],
      default: ''
    },
    multiplier: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      formattedStartDate: null,
      formattedEndDate: null,
      bonusPhaseCountdownTimer: null,
      bonusPhaseTotalDuration: null,
      isBonusPhaseRunning: false
    }
  },
  created () {
    this.initializeData()
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    ...mapState('common', [
      'hideStore'
    ]),
    modalHeaderText () {
      return this.getTranslations[`home_bundle_discount_header_x${this.multiplier}`] || ''
    },
    pointsText () {
      return this.getTranslations[`home_bundle_discount_header_points_x${this.multiplier}`] || ''
    },
    durationText () {
      return `${this.getTranslations.home_bundle_discount_duration_pt1 || ''} ${this.bonusPhaseTotalDuration} ${this.getTranslations[this.bonusPhaseTotalDuration === 1 ? 'home_bundle_discount_duration_pt2' : 'home_bundle_discount_duration_pt2_plural'] || ''}`
    },
    descriptionBetweenText () {
      const descriptionBetweenSecondPart = this.getTranslations[`home_bundle_discount_between_pt2_x${this.multiplier}`] || ''

      return (this.getTranslations.home_bundle_discount_between_pt_1 && descriptionBetweenSecondPart)
        ? `${this.getTranslations.home_bundle_discount_between_pt_1 || ''} ${this.formattedStartDate}–${this.formattedEndDate} ${descriptionBetweenSecondPart}`
        : ''
    }
  },
  methods: {
    initializeData () {
      moment.locale(localStorage.getItem('locale'))

      const currentDate = moment()
      const startDate = moment(this.startDate)
      const endDate = moment(this.endDate)

      this.formattedStartDate = startDate.format('HH:mm:ss')
      this.formattedEndDate = endDate.format('HH:mm:ss')
      this.bonusPhaseTotalDuration = Math.ceil(moment.duration(endDate.diff(startDate)).asHours())
      this.isBonusPhaseRunning = currentDate.isBefore(endDate)

      this.bonusPhaseCountdownTimer = this.isBonusPhaseRunning
        ? Math.ceil(moment.duration(endDate.diff(currentDate)).asSeconds())
        : 0
    },
    handleTimeExpired () {
      this.isBonusPhaseRunning = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BundleDiscount.vue